import { gql, useQuery } from '@apollo/client'
import { getIsSessionExpired } from '../../utils/is-session-expired.js'

const TERMS_QUERY = gql`
  query UseTerms {
    account {
      id
      consentToTerms
      termsAvailability {
        isAvailable
        termsURL
      }
    }
  }
`

export const useTerms = () => {
  const isSessionExpired = getIsSessionExpired()
  const resp = useQuery(TERMS_QUERY, {
    skip: isSessionExpired,
  })
  const { consentToTerms = false, termsAvailability = {} } = resp?.data?.account ?? {}

  return {
    ...resp, // Provide all the other Apollo things
    termsAvailability,
    consentToTerms,
  }
}
